'use strict';

var PlayerStates = require('../../../../_virtual/PlayerStates.js_commonjs-module.js');

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  BUFFERING: 3,
  ENDED: 0,
  PAUSED: 2,
  PLAYING: 1,
  UNSTARTED: -1,
  VIDEO_CUED: 5
};
module.exports = exports["default"];
}(PlayerStates.PlayerStates, PlayerStates.PlayerStates.exports));
